import { type RouteRecordRaw } from 'vue-router';

export enum MODULE_ROUTE {
  payment = 'PricingPayment',
}

export const routes: RouteRecordRaw[] = [
  {
    path: '/:lang?/pricing/payment/',
    component: () => import('@/modules/pricing/layout/LayoutPage.vue'),
    children: [
      {
        path: '',
        name: MODULE_ROUTE.payment,
        component: () =>
          import('@/modules/pricing/pages/payment/PagePayment.vue'),
        meta: {
          i18nAlias: 'pricing',
        },
      },
    ],
  },
];
